// extracted by mini-css-extract-plugin
export default {"boardPage":"BoardPage_boardPage__SR3WU"};